export default __webpack_public_path__ + "static/media/Vazir-Thin.7b6e821c.woff2";